<!--
 * @Auther: 罗耀祖
 * @Date: 2022-03-17 14:57:20
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-05-05 10:37:32
 * @name: 注册
 * @Description: 注册
 * @FilePath: \project\src\views\register\register.vue
 * @Author: desktop
-->
<template>
  <div class="register">
    <div class="card">
      <div class="info">
        <font class="title">新用户注册</font>
        <div class="line">
          <font class="label">姓名</font>
          <el-input
            class="input"
            v-model="form.real_name"
            placeholder="请输入姓名"
            clearable
          ></el-input>
        </div>
        <div class="line">
          <font class="label">手机号</font>
          <el-input
            class="input"
            v-model="form.mobile"
            maxlength="11"
            placeholder="请输入手机号"
            clearable
          ></el-input>
        </div>
        <div class="line">
          <font class="label">验证码</font>
          <el-input
            class="verify_code"
            v-model="form.verify_code"
            placeholder="请输入验证码"
            clearable
          ></el-input>
          <div
            class="verify_code_btn"
            :class="{ countdown: countdown > 0 }"
            type="primary"
            @click="sendVerify"
          >
            {{ sendVerificationCodeText
            }}{{ countdown === 0 ? "" : "(" + countdown + "s)" }}
          </div>
        </div>
        <div class="line">
          <font class="label">密码</font>
          <el-input
            type="password"
            class="input"
            v-model="form.password"
            placeholder="请输入密码"
            clearable
          ></el-input>
        </div>
        <div class="line">
          <font class="label">再次输入密码</font>
          <el-input
            type="password"
            class="input"
            v-model="password2"
            placeholder="请再次输入密码"
            clearable
          ></el-input>
        </div>
      </div>
      <div class="btnGroup">
        <el-button type="primary" @click="submit">注册</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { debounceation } from "@/utils/decorator";
import sendVerification from "@/mixins/sendVerification";
import userService from '@/module/user/user.service';
export default {
  name: "register",
  mixins: [sendVerification],
  data() {
    return {
      userService: new userService(),
      form: {
        real_name: "",
        mobile: "",
        password: "",
        verify_code: "",
      },
      password2: "",
      sendVerificationCodeText: "获取验证码",
    };
  },
  watch: {
    countdown: {
      handler(nv, ov) {
        this.sendVerificationCodeText = "重新获取";
      },
      immediate: false,
      deep: true,
    },
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 发送验证码
     */
    @debounceation(300)
    sendVerify() {
      this.sendVerificationCode(this.form.mobile);
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击注册
     */    
    @debounceation(300)
    submit() {
      if(this.form.password !== this.password2) {
        this.$message.error('请确认两次输入的密码相同!');
        return;
      }
      this.userService.register({
        ...this.form
      }).then(res => {
        this.$router.replace('/registerSuccess');
      })
    },
  },
};
</script>
<style lang="scss" scoped>
.register {
  width: 100%;
  height: 100vh;
  @extend .et-flex-center;
  background: $Vars-background-light-gray;
  .card {
    background: $Vars-base-color-white;
    padding: 40px;
    box-shadow: $Vars-boxShadow-normal;
    border-radius: $Vars-border-radius-normal;
    .info {
      width: 500px;
      @extend .et-flex-column-normal;
      .title {
        font-size: $Vars-font-mainTitle-size;
        font-weight: bold;
        margin-bottom: 20px;
      }
      .line {
        margin-top: 30px;
        @extend .et-flex-start;
        .label {
          font-size: $Vars-font-content-size;
          text-align: left;
          width: 100px;
        }
        .input {
          width: 300px;
          margin-right: 20px;
        }
        .verify_code {
          width: 170px;
          margin-right: 20px;
        }
        .verify_code_btn {
          width: 110px;
          height: 40px;
          border-radius: $Vars-border-radius-normal;
          background: $Vars-normal-color;
          @extend .et-flex-center;
          font-size: 14px;
          color: white;
          @extend .et-clickElement;
          &.countdown {
            opacity: 0.8;
          }
        }
      }
    }
    .btnGroup {
      margin-top: 30px;
      @include grid-column(auto, 200px, 10px);
      justify-content: center;
      .el-button {
        width: 200px;
        margin: 0 !important;
      }
    }
  }
}
</style>